import { AppEnvironment } from '@web/csl-lib-models';

export const environment: AppEnvironment = {
  version: '3.1.38',
  production: false,
  featureFlagEnvironment: 'dev',
  name: 'Cancer SurvivorLink Admin Portal [DEV]',
  apiUrl: 'https://cslapi.csldev.xyz',
  logoutRedirectUrl: 'https://csladm.csldev.xyz',
  msalConfig: {
    auth: {
      clientId: '7c1179b1-ace3-46ee-9e0b-d2a28effc8d4',
      authority: 'https://cslnonprod.b2clogin.com/cslnonprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_CSL',
    },
    redirectUri: 'https://csladm.csldev.xyz/dashboard',
  },
  apiConfig: {
    scopes: [
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/admin.clinics.all',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/admin.healthrecords.read',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/admin.healthrecords.write',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/admin.legalguardianrequests.all',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/admin.ownertransfers.all',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/admin.reports.read',
      'https://cslnonprod.onmicrosoft.com/csl-dev/api/admin.users.all'
    ],
    uri: 'https://cslapi.csldev.xyz', // API endpoint URL
  },
  b2cPolicies: {
    names: {
      signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN_CSL',
    },
    authorities: {
      signUpSignIn: {
        authority:
          'https://login.csldev.xyz/e5337cb4-f730-4f54-bcad-70710c429ea4/B2C_1A_SIGNUP_SIGNIN_CSL',
      }
    },
    authorityDomain: 'login.csldev.xyz',
  },
  cacheTimeInMinutes: 30,
  primeNgLicenseKey: 'eyJpZCI6ImQ1ZWEyZjA0LWQ1ZGEtNDAzOS1iMzM2LWRkODM1MWQ5Njg0ZiIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW1lcmNpYWwiLCJ0eXBlIjoiZGV2IiwiaWF0IjoxNzg0OTc4NzA1LCJleHAiOjE4MTY1MTQ2NjV9.ZXZ4cOdbvDJiyNrSiVAmPO-vJHHc6MFK23Zy573BOvR3yJboxx1ligQkH21asMOTVd44LMhshpYtmk94ZEd1AQ',
};
